exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".zenDescIcon{background:url(/ng/assets/images/pictures/support_man.png);height:48px;width:45px;position:fixed;left:10px;bottom:10px;cursor:pointer}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/zendesk-chat/zendesk-chat.component.css"],"names":[],"mappings":"AAAA,aACE,2DAA2D,YAC9C,WACD,eACI,UACL,YACE,cACG,CACjB","file":"zendesk-chat.component.css","sourcesContent":[".zenDescIcon {\n  background: url('/assets/images/pictures/support_man.png');\n  height: 48px;\n  width: 45px;\n  position: fixed;\n  left: 10px;\n  bottom: 10px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/zendesk-chat/zendesk-chat.component.css
// module id = xlbg
// module chunks = 6